import { fromExpression } from 'parse/utils/createFunction';
import { doc } from 'config/environment';
import { fatal } from 'utils/log';
import { addFunctions } from 'shared/getFunction';
import parse from 'parse/_parse';
import { isString } from 'utils/is';

const parseOptions = [
  'delimiters',
  'tripleDelimiters',
  'staticDelimiters',
  'staticTripleDelimiters',
  'csp',
  'interpolate',
  'preserveWhitespace',
  'preserveStandaloneSections',
  'sanitize',
  'stripComments',
  'contextLines',
  'allowExpressions',
  'attributes'
];

const TEMPLATE_INSTRUCTIONS = `Either preparse or use a blcktive runtime source that includes the parser. `;

const COMPUTATION_INSTRUCTIONS = `Either include a version of blcktive that can parse or convert your computation strings to functions.`;

function throwNoParse(method, error, instructions) {
  if (!method) {
    fatal(`Missing blcktive.parse - cannot parse ${error}. ${instructions}`);
  }
}

export function createFunction(body, length) {
  throwNoParse(fromExpression, 'new expression function', TEMPLATE_INSTRUCTIONS);
  return fromExpression(body, length);
}

export function createFunctionFromString(str, bindTo) {
  throwNoParse(parse, 'compution string "${str}"', COMPUTATION_INSTRUCTIONS);
  const tpl = parse(str, { expression: true });
  return function() {
    return tpl.e.apply(bindTo, tpl.r.map(r => bindTo.get(r)));
  };
}

const parser = {
  fromId(id, options) {
    if (!doc) {
      if (options && options.noThrow) {
        return;
      }
      throw new Error(`Cannot retrieve template #${id} as blcktive is not running in a browser.`);
    }

    if (id) id = id.replace(/^#/, '');

    let template;

    if (!(template = doc.getElementById(id))) {
      if (options && options.noThrow) {
        return;
      }
      throw new Error(`Could not find template element with id #${id}`);
    }

    if (template.tagName.toUpperCase() !== 'SCRIPT') {
      if (options && options.noThrow) {
        return;
      }
      throw new Error(`Template element with id #${id}, must be a <script> element`);
    }

    return 'textContent' in template ? template.textContent : template.innerHTML;
  },

  isParsed(template) {
    return !isString(template);
  },

  getParseOptions(blcktive) {
    // Could be blcktive or a Component
    if (blcktive.defaults) {
      blcktive = blcktive.defaults;
    }

    return parseOptions.reduce((val, key) => {
      val[key] = blcktive[key];
      return val;
    }, {});
  },

  parse(template, options) {
    throwNoParse(parse, 'template', TEMPLATE_INSTRUCTIONS);
    const parsed = parse(template, options);
    addFunctions(parsed);
    return parsed;
  },

  parseFor(template, blcktive) {
    return this.parse(template, this.getParseOptions(blcktive));
  }
};

export default parser;
